<script setup lang="ts">
import type { BlokTextMediaSection } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokTextMediaSection;
}>();

const contentSlotName = computed(() =>
  props.blok.isSwitched ? "rightColumn" : "leftColumn"
);
const mediaSlotName = computed(() =>
  props.blok.isSwitched ? "leftColumn" : "rightColumn"
);
</script>

<template>
  <BaseTwoColumnContainer v-editable="blok" :has-gutter="false">
    <template #[contentSlotName]>
      <BaseContentSection
        :background-color="blok.backgroundColor"
        class="flex w-full h-full items-center"
      >
        <BaseHeadline
          tag="h2"
          :emphasize="true"
          :text="blok.headline"
        ></BaseHeadline>
        <BaseRichtext
          :content="blok.text"
          class="not-first:pt-4 not-last:pb-4 whitespace-pre-line border-t"
        ></BaseRichtext>
        <BlokButton v-if="blok.button[0]" :blok="blok.button[0]"></BlokButton>
      </BaseContentSection>
    </template>
    <template #[mediaSlotName]>
      <BaseImageSlider
        :images="blok.images"
        :slides-per-view="1"
        class="image-slider h-full w-full"
    /></template>
  </BaseTwoColumnContainer>
</template>

<style lang="scss" scoped>
.image-slider {
  min-height: 300px;

  @screen sm {
    min-height: 350px;
  }

  @screen lg {
    min-height: 400px;
  }

  @screen xl {
    min-height: 500px;
  }
}
</style>
